export default {
    'offer-status': "حالة العرض",
    'offer-no': "رقم العرض",
    'payment-terms': "شروط الدفع",
    'validity-days': "مدة صلاحية العرض"
}